import BFLLink from "@repo/shared-ui/BFLLink";

interface CorporateLink {
  linkTitle?: string;
  linkUrl?: string;
  newTab?: string;
  nodeName?: string;
  children?: Array<Record<string, unknown>>;
}
interface OurCompaniesProps {
  corporateLinksTitle: string;
  corporateLinks: CorporateLink[];
}
const OurCompanies = ({ corporateLinksTitle, corporateLinks }: OurCompaniesProps) => {
  return (
    <div className="flex w-[40%] cursor-pointer flex-col md:w-[18%]!">
      <h3 className="text-sm font-medium [font-family:Rubik-Medium,Mukta-Medium,BalooThambi2-Medium,sans-serif]">{corporateLinksTitle}</h3>
      {corporateLinks?.map((link, index) => (
        <BFLLink
          key={"corpLink-" + index}
          href={link.linkUrl ?? ""}
          openInNewTab={link.newTab}
          className="mt-[8px] text-[10px] text-wrap [font-family:Rubik,Mukta,BalooThambi2,sans-serif]"
        >
          {link.linkTitle}
        </BFLLink>
      ))}
    </div>
  );
};
export default OurCompanies;
